import React, { useState } from 'react';
import './CreateGroupModal.css';

const CreateGroupModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    groupName: '',
    description: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    // Group name validation
    if (!formData.groupName.trim()) {
      newErrors.groupName = 'Group name is required';
    } else if (formData.groupName.length < 2) {
      newErrors.groupName = 'Group name must be at least 2 characters';
    } else if (formData.groupName.length > 32) {
      newErrors.groupName = 'Group name must be less than 32 characters';
    } else if (!/^[a-zA-Z0-9_-]+$/.test(formData.groupName)) {
      newErrors.groupName = 'Group name can only contain letters, numbers, hyphens, and underscores';
    }

    // Description validation (optional but with length limit)
    if (formData.description && formData.description.length > 255) {
      newErrors.description = 'Description must be less than 255 characters';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit({
        cn: formData.groupName.trim(),
        description: formData.description.trim() || undefined
      });
    } catch (error) {
      console.error('Failed to create group:', error);
      // Error handling is done in the parent component
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content create-group-modal">
        <div className="modal-header">
          <h3>Create New Group</h3>
          <button className="close-btn" onClick={onClose} disabled={isSubmitting}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="create-group-form">
          <div className="form-group">
            <label htmlFor="groupName" className="form-label">
              Group Name *
            </label>
            <input
              type="text"
              id="groupName"
              name="groupName"
              value={formData.groupName}
              onChange={handleInputChange}
              className={`form-input ${errors.groupName ? 'error' : ''}`}
              placeholder="Enter group name"
              disabled={isSubmitting}
              maxLength={32}
            />
            {errors.groupName && (
              <span className="error-message">{errors.groupName}</span>
            )}
            <div className="input-help">
              Use letters, numbers, hyphens, and underscores only
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className={`form-textarea ${errors.description ? 'error' : ''}`}
              placeholder="Enter group description (optional)"
              disabled={isSubmitting}
              maxLength={255}
              rows={3}
            />
            {errors.description && (
              <span className="error-message">{errors.description}</span>
            )}
            <div className="input-help">
              {formData.description.length}/255 characters
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Creating...' : 'Create Group'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateGroupModal;
